import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import { SEO } from './SEO';

import { Button } from '@/components/Button';
import { Spinner } from '@/components/Spinner';

const ErrorFallback = () => {
  const { t } = useTranslation('internalError');

  return (
    <div
      className="text-red-500 w-screen h-screen flex flex-col justify-center items-center"
      role="alert"
    >
      <h2 className="text-lg font-semibold">{t('title')}</h2>
      <Button className="mt-4" onClick={() => window.location.reload()}>
        {t('refreshBtn')}
      </Button>
    </div>
  );
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Spinner size="xl" />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <BrowserRouter>
            <SEO />
            {children}
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
